import axios from 'axios';
import _ from "lodash-es";
import BaseDao from "./BaseDao";
var store = {};

var _copyHasher = function(response) {
  let hasher = {};
  hasher.id = response.id;
  hasher.hash_name = response.hash_name;
  hasher.trails_hared = response.trails_hared;
  //TODO remove duplication in hares/trails somewhere better?
  hasher.trails_ran = _.difference(response.trails_ran, response.trails_hared);
  hasher.trails_attended = _.union(hasher.trails_hared, hasher.trails_ran);
  return hasher;
};
export default _.extend(_.clone(BaseDao), {
  _copyEntity: _copyHasher,
  _saveUrl : '/api/hasher/saveOrUpdate',
  _getByIdURL : '/api/hasher/byId/',
  _getByIdsURL: '/api/hasher/byIds',
  _store : store,

  fetchAllWithFilter : function(name, eager) {
    return axios.get('/api/hasher/idSearch/byName/' + name)
      .then(response => {
        let filteredIds = response.data;
        return this.fetchByIds(filteredIds, eager);
      });
  }
})
